var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-actions"},[_c('button',{staticClass:"btn btn-warning btn-micro",attrs:{"disabled":(_vm.rowData.status === 'serverImproving')},on:{"click":function($event){return _vm.onAction('view-item', _vm.rowData, _vm.rowIndex)}}},[_vm._v(_vm._s(_vm.$t('dashboard.manage')))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b61675d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/data-visualisation-tab/ManageAction.vue
// module id = yTjv
// module chunks = 35